export default function oxfordJoin(arr: string[], conjunction = 'or'): string {
  if (arr.length <= 1) {
    return arr[0] || '';
  }
  const maybeComma = arr.length > 2 ? ',' : '';
  return arr.slice(0, -1).join(', ') + `${maybeComma} ${conjunction} ` + arr.slice(-1);
}
